export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Cement plant technicians and operators, concrete laboratory technicians, batching plant supervisors, site and quality inspectors, materials engineers, precast technicians, site engineers, QA/QC staff and advanced students.',
  ],
  ['Content depth?', 'From fundamentals to professional-level manufacturing, mix design, production, testing, durability and quality control.'],
  [
    'International?',
    'Yes. Based on internationally used concepts and terminology; always follow the standards, specifications and procedures that apply where you work.',
  ],
  [
    'Format?',
    'Professional PDF files with instant access. It is technical reference material — not software, simulators, editable spreadsheets or a course with a certificate.',
  ],
  [
    'Does it replace standards or specifications?',
    'No. It does not replace the applicable standards and specifications, the project specification, the engineer of record, manufacturers’ technical data sheets, or the judgment of qualified professionals and accredited laboratories.',
  ],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
